module.exports = __webpack_public_path__ + "img/139.884176d8.jpg";